import React from 'react'
import "./agency.scss"
import recoveryAgencyHOC from './recoveryAgencyHOC'

const StashfinRecoveryAgency = ({agencyList}) => {
  return (
    <div className="mx-5">
    <div className="text-center mb-2">LIST OF RECOVERY AGENTS</div>    
    <div className="table-responsive">
    <table className="table table-sm table-bordered table-hover">
      <thead>
        <tr>
          <th>Sr No</th>
          <th>Agency Name</th>
          <th>Agency Address</th>
          <th>Contact No</th>
        </tr>
      </thead>
      <tbody>
          {
          agencyList.map(agency =>  <tr key={agency?.sr_no}>
          <td>{agency?.sr_no}</td>
          <td>{agency?.agency_name}</td>
          <td>{agency?.agency_address}</td>
          <td>{agency?.contact_no}</td>
          </tr>)
          }
      </tbody>
    </table>
  </div>
  </div>
  )
}

export default recoveryAgencyHOC(StashfinRecoveryAgency)